import {
  formatPurchasePlanningCashRequired,
  formatPurchasePlanningNumber,
} from '../../../lib/purchasePlanningHelpers';

export function ContainerOptimizationSummaryBar({ summary }) {
  if (!summary) return null;

  const cards = [
    { label: 'Container pools', value: formatPurchasePlanningNumber(summary.groupCount) },
    { label: 'SKUs pooled', value: formatPurchasePlanningNumber(summary.totalSkuCount) },
    { label: 'Group base buy', value: formatPurchasePlanningNumber(summary.totalBaseBuy) },
    { label: 'Fill units', value: formatPurchasePlanningNumber(summary.totalFill) },
    { label: 'Adjusted group units', value: formatPurchasePlanningNumber(summary.totalAdjusted) },
    { label: 'Capital exposure', value: formatPurchasePlanningCashRequired(summary.totalCash) },
  ];

  return (
    <div className="mt-4 grid gap-2 md:grid-cols-2 xl:grid-cols-6">
      {cards.map(card => (
        <div key={card.label} className="rounded-md border border-gray-200 bg-white px-3 py-2">
          <p className="text-[11px] uppercase tracking-[0.12em] text-gray-500">{card.label}</p>
          <p className="mt-1 text-lg font-semibold text-gray-900">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
